import dayjs from 'dayjs';

const DATE_TIME_FORMAT = 'dddd, D MMMM, HH:mm';

// Rendered in the browser's own timezone, so the reader is already in the frame of reference the
// time refers to — the zone suffix only added noise. HubSpot's confirmation email carries the
// authoritative zone for anyone who booked against a different one.
export const formatBookedSlot = (startsAt?: Date): string | undefined =>
  startsAt ? dayjs(startsAt).format(DATE_TIME_FORMAT) : undefined;
